import React from 'react';
import { PageWrapper } from '@monorepo/page';
import pages from './pages';
import componentsMap from './componentsMap';

const Page = () => <PageWrapper pages={pages} componentsMap={componentsMap} />;

export default Page;
